import React, { useState } from 'react';
import HoloCard from '../components/HoloCard';
import SafeIcon from '../common/SafeIcon';
import { playbooks } from '../utils/mockData';
import { motion, AnimatePresence } from 'framer-motion';

const Playbooks = () => {
  const [activePlaybook, setActivePlaybook] = useState(null);
  const [status, setStatus] = useState('idle'); // idle, running, success

  const runPlaybook = (id) => {
    setActivePlaybook(id);
    setStatus('running');
    setTimeout(() => {
      setStatus('success');
      setTimeout(() => {
        setStatus('idle');
        setActivePlaybook(null);
      }, 3000);
    }, 2500);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-light text-white tracking-wide">Automation <span className="font-bold text-cyan-400">Playbooks</span></h1>
        <p className="text-slate-500 text-sm mt-1">One-click resolution protocols for known anomalies.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {playbooks.map((pb, i) => (
          <HoloCard key={pb.id} delay={i * 0.1}>
            <div className="flex items-start space-x-4">
              <div className="p-3 bg-cyan-950/50 rounded-lg border border-cyan-800/50">
                <SafeIcon name={pb.icon} className="text-cyan-400 text-xl" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-medium text-slate-200">{pb.name}</h3>
                <p className="text-sm text-slate-500 mt-1">{pb.description}</p>
                <div className="flex items-center space-x-4 mt-3 text-xs">
                  <span className={`px-2 py-0.5 rounded ${pb.risk === 'High' ? 'bg-amber-900/30 text-amber-400 border border-amber-800/50' : 'bg-slate-800 text-slate-400'}`}>
                    Risk: {pb.risk}
                  </span>
                  <span className="text-slate-500">Est: {pb.time}</span>
                </div>
              </div>
            </div>

            <div className="mt-6 border-t border-slate-800 pt-4 flex justify-end">
              <button
                onClick={() => runPlaybook(pb.id)}
                disabled={activePlaybook !== null}
                className={`px-4 py-2 rounded text-sm font-medium transition-all flex items-center space-x-2 ${
                  activePlaybook === pb.id && status === 'running'
                    ? 'bg-amber-500/20 text-amber-400 border border-amber-500/50 cursor-wait'
                    : activePlaybook === pb.id && status === 'success'
                    ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/50'
                    : 'bg-cyan-600/20 text-cyan-300 border border-cyan-600/50 hover:bg-cyan-600/40 hover:shadow-[0_0_10px_rgba(6,182,212,0.3)] disabled:opacity-50 disabled:cursor-not-allowed'
                }`}
              >
                {activePlaybook === pb.id && status === 'running' ? (
                  <>
                    <SafeIcon name="Loader" className="animate-spin" />
                    <span>Executing Protocol...</span>
                  </>
                ) : activePlaybook === pb.id && status === 'success' ? (
                  <>
                    <SafeIcon name="Check" />
                    <span>Protocol Completed</span>
                  </>
                ) : (
                  <>
                    <SafeIcon name="Play" />
                    <span>Initialize</span>
                  </>
                )}
              </button>
            </div>
            
            {/* Progress Bar Overlay */}
            <AnimatePresence>
              {activePlaybook === pb.id && status === 'running' && (
                <motion.div 
                  initial={{ width: 0 }}
                  animate={{ width: '100%' }}
                  transition={{ duration: 2.5, ease: "linear" }}
                  className="absolute bottom-0 left-0 h-1 bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.8)]"
                />
              )}
            </AnimatePresence>
          </HoloCard>
        ))}
      </div>
    </div>
  );
};

export default Playbooks;